// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.pieContainer, .basicIndicatorContainer, .barContainer, .lineContainer {
    width: 25%;
    min-width: 300px;
    height: 300px;
    min-height: 200px;
    margin: 10px;
    border-radius: 10px;
    background-color: white;
    display: inline-block !important;
    vertical-align: top;
}

.veryBasicIndicatorContainer {
    width: 15%;
    padding: 15px;
    min-width: 300px;
    height: 140px;
    margin: 10px;
    border-radius: 1% 1% 1% 1%;
    background-color: white;
    display: inline-block !important;
    vertical-align: top;
    color: var(--main-hg-color);
    position: relative;
}

.headerTable {
    color:white;
    background-color: var(--main-hg-color);
    font-weight: bold;
    border-radius: 8px 8px 0px 0px;
}

.tableContainer {
    width: 25%;
    min-width: 300px;
    min-height: 200px;
    margin: 10px;
    border-radius: 1% 1% 1% 1%;
    background-color: white;
    display: inline-block !important;
    vertical-align: top;
}

@media (max-width: 768px) {
    .tableContainer {
        width: 100% !important;
        margin: 0px 0px 10px 0px !important;
    }
}


.basicIndicatorContainer {
    width: 15%;
    padding: 15px;
    /*min-width: 300px;*/
    color: var(--main-hg-color);
    position: relative;
}

.barContainer svg {
    height: 100% !important;
}

/* Todo : gérer l'affichage en fonction du toggle */
.barContainer div:not([style*="position: absolute"]) {
    height: 100%;
}

.titleN {
    /*font-size: 15px;*/
    font-weight: bold;
    text-align: left;
}

.numberNvar {
    border-radius: 12px;
    background-color: var(--highlight-bg-color);
    color : white;
    text-align: center;
    font-weight: bold;
    padding: 5px;
}

.titleN1, .numberN, .numberN1 {
    text-align: center;
}

.MuiDataGrid-footerContainer {
    height: 0px !important;
    padding: 0px !important;
    margin: 0px !important;
}

.MuiTablePagination-toolbar {
    min-height: 2px !important;
}

.MuiTablePagination-displayedRows {
    margin-top: 9px;
}

.MuiTablePagination-root * {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
    /*padding: 0px !important;*/
}

.MuiDataGrid-cell:not([data-colindex="0"]) {
    text-align: right !important;
}

.exportTable {
    background-color: var(--main-light-hg-color) !important;
}

@media (max-width: 768px) {
    .pieContainer, .basicIndicatorContainer, .barContainer, .lineContainer {
        width: 100% !important;
        margin: 20px 0px 0px 0px !important;
    }

    .basicIndicatorContainer {
        height: 27% !important;
        padding: 10px !important;
        min-height: 0px !important;
    }

    .lastIndic {
        margin-bottom: 20px !important;
    }

    .numberN, .numberN1 {
        font-size: 17px !important;
        font-weight: bold;
    }

    p {
        line-height: 1.2em;
    }

}
`, "",{"version":3,"sources":["webpack://./src/styles/chart.css"],"names":[],"mappings":";AACA;IACI,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ,0BAA0B;IAC1B,uBAAuB;IACvB,gCAAgC;IAChC,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,sCAAsC;IACtC,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,0BAA0B;IAC1B,uBAAuB;IACvB,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI;QACI,sBAAsB;QACtB,mCAAmC;IACvC;AACJ;;;AAGA;IACI,UAAU;IACV,aAAa;IACb,oBAAoB;IACpB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA,mDAAmD;AACnD;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,2CAA2C;IAC3C,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;IAC7B,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uDAAuD;AAC3D;;AAEA;IACI;QACI,sBAAsB;QACtB,mCAAmC;IACvC;;IAEA;QACI,sBAAsB;QACtB,wBAAwB;QACxB,0BAA0B;IAC9B;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,0BAA0B;QAC1B,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;;AAEJ","sourcesContent":["\n.pieContainer, .basicIndicatorContainer, .barContainer, .lineContainer {\n    width: 25%;\n    min-width: 300px;\n    height: 300px;\n    min-height: 200px;\n    margin: 10px;\n    border-radius: 10px;\n    background-color: white;\n    display: inline-block !important;\n    vertical-align: top;\n}\n\n.veryBasicIndicatorContainer {\n    width: 15%;\n    padding: 15px;\n    min-width: 300px;\n    height: 140px;\n    margin: 10px;\n    border-radius: 1% 1% 1% 1%;\n    background-color: white;\n    display: inline-block !important;\n    vertical-align: top;\n    color: var(--main-hg-color);\n    position: relative;\n}\n\n.headerTable {\n    color:white;\n    background-color: var(--main-hg-color);\n    font-weight: bold;\n    border-radius: 8px 8px 0px 0px;\n}\n\n.tableContainer {\n    width: 25%;\n    min-width: 300px;\n    min-height: 200px;\n    margin: 10px;\n    border-radius: 1% 1% 1% 1%;\n    background-color: white;\n    display: inline-block !important;\n    vertical-align: top;\n}\n\n@media (max-width: 768px) {\n    .tableContainer {\n        width: 100% !important;\n        margin: 0px 0px 10px 0px !important;\n    }\n}\n\n\n.basicIndicatorContainer {\n    width: 15%;\n    padding: 15px;\n    /*min-width: 300px;*/\n    color: var(--main-hg-color);\n    position: relative;\n}\n\n.barContainer svg {\n    height: 100% !important;\n}\n\n/* Todo : gérer l'affichage en fonction du toggle */\n.barContainer div:not([style*=\"position: absolute\"]) {\n    height: 100%;\n}\n\n.titleN {\n    /*font-size: 15px;*/\n    font-weight: bold;\n    text-align: left;\n}\n\n.numberNvar {\n    border-radius: 12px;\n    background-color: var(--highlight-bg-color);\n    color : white;\n    text-align: center;\n    font-weight: bold;\n    padding: 5px;\n}\n\n.titleN1, .numberN, .numberN1 {\n    text-align: center;\n}\n\n.MuiDataGrid-footerContainer {\n    height: 0px !important;\n    padding: 0px !important;\n    margin: 0px !important;\n}\n\n.MuiTablePagination-toolbar {\n    min-height: 2px !important;\n}\n\n.MuiTablePagination-displayedRows {\n    margin-top: 9px;\n}\n\n.MuiTablePagination-root * {\n    margin-top: 0px !important;\n    margin-bottom: 0px !important;\n    /*padding: 0px !important;*/\n}\n\n.MuiDataGrid-cell:not([data-colindex=\"0\"]) {\n    text-align: right !important;\n}\n\n.exportTable {\n    background-color: var(--main-light-hg-color) !important;\n}\n\n@media (max-width: 768px) {\n    .pieContainer, .basicIndicatorContainer, .barContainer, .lineContainer {\n        width: 100% !important;\n        margin: 20px 0px 0px 0px !important;\n    }\n\n    .basicIndicatorContainer {\n        height: 27% !important;\n        padding: 10px !important;\n        min-height: 0px !important;\n    }\n\n    .lastIndic {\n        margin-bottom: 20px !important;\n    }\n\n    .numberN, .numberN1 {\n        font-size: 17px !important;\n        font-weight: bold;\n    }\n\n    p {\n        line-height: 1.2em;\n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
